import React from 'react';
import { CURRENT_STATUS } from '../../../utils/constants';
import { Tooltip } from '@mui/material';

const CurrentStatusDot = props => {
  let dotColor = '#6c757d';
  switch (props?.value) {
    case CURRENT_STATUS.BLACK:
      dotColor = '#232321';
      break;
    case CURRENT_STATUS.OFFLINE:
      dotColor = 'red';
      break;
    case CURRENT_STATUS.ALERT:
      dotColor = '#ffc107';
      break;
    case CURRENT_STATUS.ONLINE:
      dotColor = '#86cc1a';
      break;
    case CURRENT_STATUS.ABNORMAL:
      dotColor = '#fa6427';
      break;
    case CURRENT_STATUS.UNDEFINED:
    default:
      dotColor = '#6c757d';
      break;
  }
  return (
    <div className={'form-inline d-flex align-items-center'} style={{ position: 'relative', height: '15px' }}>
      {props.tooltipTitle ? (
        <Tooltip  title={props.tooltipTitle} arrow>
          <div
            style={{
              borderRadius: '50%',
              height: '10px',
              width: '10px',
              background: dotColor,
            }}
          />
        </Tooltip>
      ) : (
        <div
          style={{
            borderRadius: '50%',
            height: '10px',
            width: '10px',
            background: dotColor,
          }}
        />
      )}
    </div>
  );
};
export default React.memo(CurrentStatusDot);
CurrentStatusDot.whyDidYouRender = true;
